import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Textarea } from '@/components/ui/textarea'
import { LoaderCircle } from 'lucide-react'
import { useState } from 'react'
import type { MemoryCopy } from './types'

interface Props {
  copy: MemoryCopy
  initialText: string
  initialContext?: string | null
  processing: boolean
  onCancel: () => void
  onSave: (text: string, context: string) => void
}

export default function MemoryEditForm({ copy, initialText, initialContext, processing, onCancel, onSave }: Props) {
  const [text, setText] = useState(initialText)
  const [context, setContext] = useState(initialContext || '')

  return (
    <div className="space-y-5 p-5">
      <div>
        <h4 className="text-sm font-semibold text-foreground">{copy.detail.edit_title}</h4>
        <p className="mt-1 text-xs leading-5 text-muted-foreground">{copy.detail.edit_description}</p>
      </div>
      <div className="space-y-2">
        <Label htmlFor="memory-edit-content">{copy.add.content_label}</Label>
        <Textarea id="memory-edit-content" autoFocus rows={9} maxLength={100000} value={text} onChange={(event) => setText(event.target.value)} className="min-h-56 resize-y leading-6" />
      </div>
      <div className="space-y-2">
        <Label htmlFor="memory-edit-context">{copy.add.context_label}</Label>
        <Input id="memory-edit-context" type="text" maxLength={4000} value={context} onChange={(event) => setContext(event.target.value)} />
      </div>
      <div className="flex justify-end gap-2 pt-2">
        <Button type="button" variant="ghost" onClick={onCancel} disabled={processing}>{copy.detail.cancel}</Button>
        <Button type="button" onClick={() => onSave(text.trim(), context.trim())} disabled={processing || !text.trim()}>
          {processing && <LoaderCircle className="animate-spin" />}
          {processing ? copy.detail.updating : copy.detail.save}
        </Button>
      </div>
    </div>
  )
}
